// Use $ instead of jQuery
(function($) {
    // Applied immediately (not inside document.ready) so body.new-nav is
    // available to CSS as early as possible.
    if ($('.header').hasClass('new-plus-nav') || $('.header').hasClass('secondary-navigation')) {
        $('body').addClass('new-nav');
    }

    // Shared helpers (previously duplicated in multiple handlers)
    function clearSearchState() {
        $(".header .main-nav #nav_search_box").removeClass("searchbox-active");
        $(".header .main-nav .we-left-nav").removeClass("no-opacity");
        $(".header .main-nav #nav_search_box .searchBox-input").val("");
        $(".header ul.right-nav").css("position", "inherit");
    }

    function removeRegularHeaderFooterIfLibrary() {
        if ($('header.library').length > 0) {
            $('header.regular').remove();
            $('footer.regular').remove();
        }
    }

    function handleSearchEnterKey(e) {
        if (e.key === "Enter" || e.keyCode === 13) {
            e.preventDefault();
            window.location.href = "/search?query=" + encodeURIComponent($(this).val());
        }
    }

    function markViewAllLink(applyHeadingFix) {
        return function() {
            var text = $(this).text();
            if (text === 'View All') {
                $(this).addClass('link-with-black');
                $(this).contents().wrapAll("<span></span>");
                if (applyHeadingFix) {
                    $(this).parent().parent().find('li:first-child').addClass("heading");
                }
            }
        };
    }

    function pushNavClickEvent(category, navLabel, extra) {
        dataLayer.push($.extend({event: 'navigation_click', event_category: category, link_text: navLabel}, extra || {}));
    }

    // "Old" (non new-plus-nav) desktop mega-menu open/close toggle
    function openMegaMenuDropdown($item, navLabel) {
        $(".header ul .inner-menu").removeClass("hover-active");
        $(".header .main-nav").addClass("drop-down-open");
        $item.addClass("hover-active rotate-arrow");
        pushNavClickEvent('Primary Navigation Click Open', navLabel);
    }

    function closeMegaMenuDropdown($item, navLabel) {
        $item.removeClass("hover-active rotate-arrow");
        pushNavClickEvent('Primary Navigation Click Close', navLabel);
    }

    // Mobile (<1025px) sliding mega-menu panels
    function closeAllMobileMegaMenuPanels() {
        $(".header .main-nav .we-left-nav > li").removeClass("rotate-arrow");
        $(".header .we-left-nav > li .mega-menu").stop(true, true).slideUp(500);
    }

    function toggleMobileMegaMenuPanel($parentLi) {
        if ($parentLi.hasClass("rotate-arrow")) {
            $parentLi.removeClass("rotate-arrow");
            $parentLi.find(".mega-menu").stop(true, true).slideUp(500);
        } else {
            closeAllMobileMegaMenuPanels();
            $parentLi.addClass("rotate-arrow");
            $parentLi.find(".mega-menu").stop(true, true).slideDown(500);
        }
    }

    function handleInnerMenuClick(e) {
        var $item = $(this);
        var navLabel = $item.children('a').text();
        var $header = $item.closest('.header');
        // Only fall back to the old open-dropdown-and-block-navigation
        // behavior when we can positively confirm this item lives in an
        // old-style header. If .closest('.header') ever comes up empty
        // (e.g. this fires mid-render), that must never be read as "old
        // nav" - it would silently swallow the click's navigation instead
        // of letting the <a> just go to its href.
        var usesOldMegaMenuToggle = $header.length > 0 && !$header.hasClass('new-plus-nav');

        if (usesOldMegaMenuToggle) {
            e.preventDefault();
            e.stopPropagation();

            if ($item.hasClass("hover-active")) {
                closeMegaMenuDropdown($item, navLabel);
            } else {
                openMegaMenuDropdown($item, navLabel);
            }

            // Only lock body scroll (overflow: hidden) when a mega-menu is
            // actually being toggled open in place. On new-plus-nav headers
            // this click isn't prevented and navigates to a new page, so
            // toggling overflow here just hides the scrollbar for an instant
            // and causes a horizontal layout jerk right as the page unloads.
            $("body").addClass("overlay-open");
            clearSearchState();
        }
        pushNavClickEvent('Primary Navigation Click Close', navLabel);
    }

    // MyHoover login-popup item. Its mega-menu must open on every header type
    // (including new-plus-nav headers, where regular nav items skip the JS
    // toggle) since it has no real href to fall back on and its dropdown is
    // only ever shown via the hover-active class, never via new-plus-nav's
    // own mechanism. The mobile "plus-icon" variant already has its own
    // slide-panel toggle (see the .plus-icon > a handler below), so it's
    // excluded here to avoid fighting that with the desktop hover-active CSS.
    function handleSignInMegaMenuClick(e) {
        var $item = $(this);
        var navLabel = $item.children('a').text();

        // On new-plus-nav headers the My Feed link lives *inside* this sign-in
        // item, so a signed-in user's click bubbles up here. Once MyHoover has
        // resolved the session it gives that anchor a real href — treat that as
        // "let the link navigate" and don't hijack the click into the login
        // mega-menu (which would also strand `overlay-open` on the body).
        if ($(e.target).closest('a.myhoover-myfeed-btn[href]').length) {
            return;
        }

        if (!$item.hasClass('plus-icon')) {
            e.preventDefault();
            e.stopPropagation();

            if ($item.hasClass("hover-active")) {
                closeMegaMenuDropdown($item, navLabel);
            } else {
                openMegaMenuDropdown($item, navLabel);
            }
        }

        $("body").addClass("overlay-open");
        clearSearchState();
        pushNavClickEvent('Primary Navigation Click Close', navLabel);
    }

    $(document).ready(function() {
        setTimeout(function() {
            $('.header .drupal-menu ul li').each(function() {
                var value = $(this).find('a').attr('title');
                if (value !== undefined && value !== '') {
                    $(this).append('<p>' + value + '</p>');
                }
            })
        }, 1000);

        $(".header ul .about .mega-menu .top-links .col-wrap .col-three").each(function() {
            $(this).find("li:first-child").addClass('heading');
        });

        $(document).on("click", ".header .top-nav li > a", function(e) {
            var navLabel = $(this).text().trim();
            var currentUrl = $(this).prop('href');
            pushNavClickEvent('Eyebrow Navigation click', navLabel, {link_url: currentUrl});
        })

        if ($('.toolbar-tray-open').length > 0) {
            setTimeout(removeRegularHeaderFooterIfLibrary, 1000);
        } else {
            removeRegularHeaderFooterIfLibrary();
        }

        $(document).on("click", ".header ul .inner-menu:not(.sign-in)", handleInnerMenuClick);
        $(document).on("click", ".header ul .inner-menu.sign-in", handleSignInMegaMenuClick);

        $(document).on("click", "body .header ul .mega-menu .top-links .col-wrap li > a" ,
            function(e) {
                var navLabel = $(this).text();
                var currentUrl = $(this).prop('href');
                var parentLabel = $(this).closest('.inner-menu').find('> a').text();
                pushNavClickEvent('Drop Down Navigation click', navLabel, {parent_navigation_label: parentLabel, link_url: currentUrl});
                $("body").removeClass("overlay-open");
                $(".header ul .inner-menu").removeClass("hover-active");
            }
        );

        $(document).on(
            "click",
            ".header ul .mega-menu .col-outer .close-btn",
            function(e) {
                e.stopPropagation();
                $(".header ul .inner-menu").removeClass("hover-active rotate-arrow");
                $(".header .main-nav").removeClass("drop-down-open");
                $("body").removeClass("overlay-open");
            }
        );
        $(document).on("click", ".header ul .mega-menu", function(e) {
            e.stopPropagation();
            $(".header ul .inner-menu").removeClass("hover-active");
            $(".header .main-nav").removeClass("drop-down-open");
            $("body").removeClass("overlay-open");
        });
        $(document).on("click", ".header ul .mega-menu .col-outer", function(e) {
            e.stopPropagation();
        });
        $(document).on(
            "click",
            ".header ul .mega-menu .bottom-search .search-box .search-input",
            function(e) {
                e.stopPropagation();
            }
        );

        $(document).on(
            "click",
            ".header ul > li .mega-menu .col-outer ",
            function(e) {
                e.stopPropagation();
            }
        );

        $(".header .we-left-nav > li.library > a").on("click", function(e) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        });

        $(".header .we-left-nav").on("click", function(e) {
            var winWidth = $(window).width();
            if (winWidth < 1025) {
                e.stopPropagation();
            }
        });

        $(document).on(
            "keydown",
            "#nav_search_box .searchBox-input, #nav_search_box_small .searchBox-input",
            handleSearchEnterKey
        );
        $(document).on("click", ".nav-search-box-small .searchBox-submit", function(e) {
            e.preventDefault(); 
            let val = $(".nav-search-box-small .searchBox-input").val()
            if (val) {
                window.location.href = "/search?query=" + encodeURIComponent(val);
            }
        });

        $(".nav-search-box .searchBox-reset").on("click", function(e) {
            $(".nav-search-box .searchBox-input").val("");
        });

        $(document).on("click", "#nav-search-close-btn", function(e) {
            e.preventDefault();
            e.stopPropagation();
            var $windowWidth = $(window).width();
            if ($windowWidth < 1025) {
                $("#nav_search_box_small").removeClass("searchbox-active");
                $("#nav_search_box_small .searchBox-input").val("");
                $(".header ul.right-nav").css("position", "inherit");
            }
        });

        // Search Overlay
        $(document).on("click", ".header ul > li.search", function(e) {
            e.stopPropagation();
            $(".header ul.right-nav").css("position", "relative");

            $(".we-left-nav").addClass("no-opacity")
            $("#nav_search_box").addClass("searchbox-active");
            $(".header ul .inner-menu").removeClass("hover-active");
            $(".header .main-nav").removeClass("drop-down-open");
            $("#nav_search_box input").focus();

            if($("#nav_search_box .searchBox-input").val()){
                window.location.href = "/search?query=" + encodeURIComponent($("#nav_search_box .searchBox-input").val());
            }
        });

        $(document).on(
            "click",
            ".header .toggle-wrap .search, .header .right-nav > li.search",
            function (e) {
                e.stopPropagation();

                var $searchBox = $("#nav_search_box_small");

                $(".header ul.right-nav").css("position", "relative");
                $searchBox.toggleClass("searchbox-active");

                $(".header ul .inner-menu").removeClass("hover-active");
                $(".header .main-nav").removeClass("drop-down-open");
                $(".header .main-nav .we-left-nav").removeClass("animate");
                $(".header .main-nav .hamburger").removeClass("active");

                if ($searchBox.hasClass("searchbox-active")) {
                $searchBox.find("input").trigger("focus");
                }
            }
        );

        $(".search-box .search-input")
            .focus(function() {
                $(this).parent().addClass("selected-state");
            })
            .blur(function() {
                $(this).parent().removeClass("selected-state");
            });

        $(".bottom-search .search-box .search-input").keyup(function() {
            var $val = $(this).val();
            if ($val.length > 0) {
                $(this).parent().find(".input-corss").css({ opacity: "1" });
            } else {
                $(this).parent().find(".input-corss").css({ opacity: "0" });
            }
        });
        $(".bottom-search .search-box .input-corss").on("click", function(e) {
            $(".bottom-search .search-box .search-input").val("");
            $(".bottom-search .search-box .input-corss").css({ opacity: "0" });
        });

        // Inner Menu functionality
      // Inner Menu functionality
        $(".header .main-nav .we-left-nav > .plus-icon > a").on("click", function(e) {
            var windowWidth = $(window).width();
            var $header = $(this).closest(".header");
            // Fail open toward "new nav" (navigate normally) if the header
            // can't be found, same reasoning as handleInnerMenuClick above.
            var isNewNav = $header.length === 0 || $header.hasClass("new-plus-nav");

            // Prevent default only for old navigation
            if (!isNewNav) {
                e.preventDefault();
            }

            // Only toggle mobile mega menu for old navigation
            if (windowWidth < 1025 && !isNewNav) {
                toggleMobileMegaMenuPanel($(this).parent());
            }
        });

        // Toggle functionality
        $(document).on("click", ".header .main-nav .hamburger", function(e) {
            e.stopPropagation();
            var $windowWidth = $(window).width();
            if ($windowWidth < 1025) {
                $(this).toggleClass("active");
                if (!$(this).hasClass("active")) {
                    closeAllMobileMegaMenuPanels();
                }
                $(".header .main-nav .we-left-nav").toggleClass("animate");
                $("body").toggleClass("open");
                $(".nav-search-box-small").removeClass("searchbox-active");
            }
        });

        $(document).on("click", function(e) {
            var $windowWidth = $(window).width();
            const $target = $(e.target);
            if ($windowWidth < 1025) {
                $("body").removeClass("open");
                $(".header .main-nav .hamburger").removeClass("active");
                $(".header .main-nav .we-left-nav").removeClass("animate");
                $(".header .main-nav .we-left-nav > li").removeClass("rotate-arrow");
                $(".header .main-nav .we-left-nav").stop(true, true).slideUp(500);

                if (
                    !$target.closest(".nav-search-box-small").length
                ) {
                    $(".nav-search-box-small").removeClass("searchbox-active");
                    $(".header ul.right-nav").css("position", "inherit");
                }

            }
            if ($windowWidth > 1025) {
                $(".header ul .inner-menu").removeClass("hover-active");
                
                if (
                    !$target.closest(".search").length &&
                    !$target.hasClass("searchBox-input") &&
                    !$target.hasClass("searchBox-reset")
                ) {
                    clearSearchState();
                }

            }
        });
    });

    $(window)
        .on("resize", function() {
            var $windowWidth = $(window).width();
            clearSearchState();

            if ($windowWidth > 1025) {
                $(".header .main-nav .we-left-nav > li").removeClass("rotate-arrow");
                $(".header .main-nav .we-left-nav").removeAttr("style", "");
                $(".header .main-nav .we-left-nav").removeClass("animate");
                $(".header ul .mega-menu").removeAttr("style", "");
                $(".header .main-nav .hamburger").removeClass("active");
                $(".header .main-nav .view-more-nav li > a").removeClass("active");
                $(this).parent().siblings(".plus-icon").removeClass("menu-active");
                $("body").removeClass("open");
                $("body").removeClass("overlay-open");
                $("header .view-more-nav").removeAttr("style");
            }
            $(".header .main-nav .we-left-nav > li").removeClass("hover-active");
        })
        .resize();

    function iPad() {
        $(".ua-mobile header .main-nav .we-left-nav > li.plus-icon > a").click(
            function(e) {

                 var $header = $(this).closest(".header");
                 var isNewNav = $header.length === 0 || $header.hasClass("new-plus-nav");

                if (!isNewNav) {
                    e.preventDefault();
                }
            }
        );
    }

    
    $(document).ready(function() {
        iPad();
        // hoverState();
        $(document).on(
            "mouseover",
            ".header .we-left-nav > li .mega-menu .top-links .col-wrap .inner-link > a",
            function() {
                $(this).parent().parent().find(".active").removeClass("active");
                $(this).parent().addClass("active");
            }
        );

        banner_second_level();
    });

    function banner_second_level() {
        $("body .banner-second-level .text-wrap h1").each(function() {
            var val = $(this).text();
            if (
                val == "Hoover Research" ||
                val == "HOOVER RESEARCH" ||
                val == "Research"
            ) {
                $(".header .we-left-nav > li.research").addClass("active");
                $(".header .we-left-nav > li.research-services").addClass("active");
            }
            if (val == "Library & Archives" || val == "LIBRARY & ARCHIVES") {
                $(".header .we-left-nav > li.about-library").addClass("active");
                $(".header .we-left-nav > li.library").addClass("active");
            }
            if (val == "About Us" || val == "ABOUT US") {
                $(".header .we-left-nav > li.about").addClass("active");
            }
            if (val == "Our Fellows" || val == "OUR FELLOWS") {
                $(".header .we-left-nav > li.fellows").addClass("active");
            }
        });
    }

    $(window).on("load", function() {
        var url = window.location.pathname;
        var domain = url.split("/");
        var finalVal = domain[1];
        $("body .header .we-left-nav li.inner-menu").each(function() {
            if ($(this).hasClass(finalVal)) {
                $(this).addClass("active");
            }
        });
        $("body .header ul .mega-menu .top-links .col-wrap li > a").on(
            "click",
            function() {
                if ($(this).prop("hash").length) {
                    var href = $(this).prop("hash").split("#")[1];
                    $("section").each(function() {
                        var secID = $(this).attr("id");
                        if (secID === href) {
                            $("html, body").animate({
                                    scrollTop: $("section#" + href).offset().top - 70,
                                },
                                1000
                            );
                        }
                    });
                }
            }
        );
        if (window.location.hash) {
            var urlID = window.location.hash;
            var idVal = urlID.split("#")[1];
            $("section").each(function() {
                var secID = $(this).attr("id");
                if (secID === idVal) {
                    $("html, body").animate({
                            scrollTop: $("section#" + idVal).offset().top - 120,
                        },
                        1000
                    );
                }
            });
        }
        $([
            '.header ul .commentary .mega-menu .top-links .col-wrap li.inner-link:nth-child(4) .sub-menu-block ul li a',
            '.header ul .commentary .mega-menu .top-links .col-wrap li.inner-link:nth-child(3) .sub-menu-block ul li a'
        ].join(', ')).each(markViewAllLink(true));

        $([
            '.header ul .research .mega-menu .top-links .col-wrap li.inner-link:nth-child(4) .sub-menu-block ul li a',
            '.header ul .fellows .mega-menu .top-links .col-wrap li.inner-link:nth-child(1) .sub-menu-block ul li a',
            '.header ul .fellows .mega-menu .top-links .col-wrap li.inner-link:nth-child(2) .sub-menu-block ul li a'
        ].join(', ')).each(markViewAllLink(false));

        $('.header ul .mega-menu .top-links .col-wrap li.inner-link .sub-menu-block ul li a').each(function() {
            var text = $(this).text();
            if (text === 'Overview' || text === 'PERIODICALS' || text === 'Periodicals') {
                $(this).parent().addClass('heading');
            }
        });
    });


    if ($('body .shorthand_story').length > 0) {
        $(window).on('scroll', function() {

            var scroll = $(window).scrollTop();
            if (scroll > 5) {
                $('.Theme-HeaderContainer').attr('style', 'position:fixed !important; top:128px !important');
                $('#atricle').css('style', 'top: 92px;')
            }

            if ($(window).width() < 1025) {
                $('.Theme-HeaderContainer').attr('style', 'position:fixed !important; top:64px !important');
            }
        });
    }
    $(document).on("submit", ".navsearchbox form", function(e) {
        e.preventDefault();
        const inputValue = $(this).find(".search-input").val();
        localStorage.setItem("searchText", inputValue);
        window.location = "/search?query=" + encodeURIComponent(inputValue);
    });
    $(document).on("click", ".header .we-left-nav > li", function() {
        $('.header .we-left-nav > li').removeClass("rotate-arrow")
    });
})(jQuery);

